import React from 'react';
import {connect} from 'react-redux';
import { setSimActivationList, changeHandler, validateHandler, initValidation } from './simActivationSlice';
import Config from '../../../../Config';
import TextInputWithPrefix from '../../../Shared/TextInputWithPrefix/TextInputWithPrefix';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {reportAnalytics} from '../saleBlockSlice';

const SimActivation = (props) => {
  
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      console.info('simActivation - products', props.products);
      props.setSimActivationList(props.products);
    }   
    props.initValidation(); 
  }, []);


  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.onSubmit && props.onSubmit == true) {
        props.initValidation();
        props.validateHandler();
      }      
    }    
  }, [props.onSubmit]); 


  useExtendedEffect((runSideEffects) => {
      if (runSideEffects()) {
          props.onValid(props.form.valid);
      }
    },
    [props.form.valid]
  );


  return (
    <div className="sim-activation-wrapper">
          {
            props.simActivationList && props.simActivationList.length > 0 && 
            props.simActivationList.map(function (sim, i) {  

              return (
                <div className="sim-activation-item" key={i}>
                  <div className="sim-activation-title"> קו {i+1} - {sim.phone} </div>
                  <div className="field-wrapper">
                    <TextInputWithPrefix 
                        prefixText = {Config.simActivationCodePrefix}
                        error = {props.form.errors['product_' + i]}
                        placeholder='מספר סים'
                        id={`txtSim-${sim.phone}`}
                        name={`txtSim-${sim.phone}`}
                        type='tel'
                        maxLength='10'
                        autoComplete='off'
                        value={sim.simActivationCode}
                        onChange={(e) => props.changeHandler({ value: e.target.value, index: i })}
                        required='required'
                    />
                  </div>
                </div>
              )
            })         
          }
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    simActivationList: state.simActivation.simActivationList,
    form: state.simActivation.form
  };
};

const mapDispatchToProps = {
  setSimActivationList, 
  changeHandler,
  validateHandler,
  initValidation
};

export default connect(mapStateToProps, mapDispatchToProps)(SimActivation);
